import PropTypes from "prop-types";
import Button from "../Button";
import siteRootRedirect from "../siteRootRedirect";

const StartShoppingButton = ({ className }) => (
  <Button
    action={siteRootRedirect}
    contentKey={"saved_items_continue_shopping_btn"}
    className={className}
  />
);

StartShoppingButton.propTypes = {
  className: PropTypes.string
};

export default StartShoppingButton;
